module.exports = __webpack_public_path__ + "static/jeff-bezos-917218f95ce1efc8e282d3970ca4e341.jpg";